import React from "react";
import {
  Grid,
  Skeleton,
  Typography,
  Card,
  CardContent,
  Divider,
} from "@mui/material";

const LoanPlanDetailSkeleton = () => {
  return (
    <div>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        bgcolor="#F6F8F9"
        sx={{ borderRadius: 2, p: 2, border: "1px solid #EDEFEF", mb: 2 }}
      >
        <Grid item md={7} xs={8} container spacing={2}>
          <Grid item>
            <Skeleton variant="circular" width={50} height={50} />
          </Grid>
          <Grid item>
            <Skeleton variant="text" width={150} height={30} />
            <Skeleton
              variant="rectangular"
              width={100}
              height={25}
              sx={{ mt: 1 }}
            />
          </Grid>
        </Grid>

        <Grid item xs={4} md={5} textAlign="left">
          <Skeleton variant="text" width={120} height={25} />
        </Grid>
      </Grid>

      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            <Skeleton width={150} />
          </Typography>
          <Grid container spacing={2}>
            {[...Array(4)].map((_, idx) => (
              <Grid item xs={12} sm={6} key={idx}>
                <Skeleton height={20} />
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>

      <Skeleton variant="text" width={200} height={30} sx={{ mt: 2, mb: 1 }} />
      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent>
          {[...Array(3)].map((_, idx) => (
            <Skeleton key={idx} height={30} sx={{ mb: 1 }} />
          ))}
        </CardContent>
      </Card>

      <Skeleton variant="text" width={200} height={30} sx={{ mt: 2, mb: 1 }} />
      {[...Array(2)].map((_, i) => (
        <Card
          variant="outlined"
          sx={{ mb: 2, backgroundColor: "#F6F8F9" }}
          key={i}
        >
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Skeleton variant="circular" width={40} height={40} />
              </Grid>
              <Grid item>
                <Skeleton width={120} height={30} />
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} />
            {[...Array(4)].map((_, idx) => (
              <Skeleton key={idx} height={25} sx={{ mb: 1 }} />
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default LoanPlanDetailSkeleton;
